import { useAtomValue } from 'jotai';
import { ReactSVG } from 'react-svg';
import classNames from 'classnames';
// import LangSwitchDropdown from '@/components/LangSwitchDropdown';
import Link from '@/components/Link';
import NewLabel from '@/components/NewLabel';

import { topPanelAtom } from '@/store/common';

import styles from './top-panel.module.css';

const TopPanel = () => {
  const { left, right } = useAtomValue(topPanelAtom);

  return (
    <div className={styles.root}>
      <div className={classNames('container', styles.container)}>
        <div className={styles.links}>
          {left.map(({ name, href, icon }) => (
            <Link href={href} className={styles.link} target={href.startsWith('http') ? '_blank' : undefined} key={name}>
              {icon && <ReactSVG className={styles.icon} src={icon} wrapper="span" />}
              {name}
            </Link>
          ))}
        </div>
        <div className={styles.scrollingContainer}>
          <NewLabel />
          <div className={styles.scrollingText}>
            <div className={styles.scrollingList}>
              <Link href="/sign" className={styles.scrollingItem}>
                Подписание с ПЭП по SMS
              </Link>
              <Link href="/partnership" className={styles.scrollingItem}>
                Партнерская программа
              </Link>
              {/*<Link href="/request" className={styles.scrollingItem}>
                Перенос до 5-ти документов
              </Link>*/}
              <Link href="/sign" className={styles.scrollingItem}>
                Подписание с ПЭП по SMS
              </Link>
            </div>
          </div>
          <ReactSVG src="/icons/chevron-right.svg" className={styles.arrow} />
        </div>
        <div className={styles.links}>
          {right.map(({ name, href, icon }) => (
            <Link href={href} className={styles.link} target={href.startsWith('http') ? '_blank' : undefined} key={name}>
              {icon && <ReactSVG className={styles.icon} src={icon} wrapper="span" />}
              {name}
            </Link>
          ))}
          {/* {main?.company && (
            <>
              <Link href={phone.href} className={styles.link} title={phone.title}>
                <ReactSVG className={styles.icon} src={phone.icon} wrapper="span" />
                {phone.title}
              </Link>
              <Link href={whatsapp.href} className={styles.link} title={whatsapp.title} target="_blank">
                <ReactSVG className={styles.icon} src={whatsapp.icon} wrapper="span" />
              </Link>
              <Link href={telegram.href} className={styles.link} title={telegram.title} target="_blank">
                <ReactSVG className={styles.icon} src={telegram.icon} wrapper="span" />
              </Link>
            </>
          )} */}
          {/* <LangSwitchDropdown /> */}
        </div>
      </div>
    </div>
  );
};

export default TopPanel;
